/* DEEN INTR. – product page: mirror the selected Kaching bundle price into our price row, hide on non-bundle pages. All discount percentages are rounded DOWN to a multiple of 5. */
(function () {
  function vis(el) { return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length)); }
  function txt(el) { return el ? (el.textContent || '').trim() : ''; }
  function floor5(n) { return Math.floor(n / 5) * 5; }
  /* Kaching bars print their own "Save 26%" / "-26%" labels: round those down to 5 as well */
  function roundPercents(root) {
    if (!root || !document.createTreeWalker) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false), n;
    while ((n = w.nextNode())) {
      var v = n.nodeValue;
      if (!v || v.indexOf('%') < 0) continue;
      var r = v.replace(/(\d{1,2})(\s*%)/g, function (m, d, p) {
        var x = parseInt(d, 10);
        return (x % 5 === 0 || x >= 100) ? m : floor5(x) + p;
      });
      if (r !== v) n.nodeValue = r;
    }
  }
  function sync() {
    var hostAll = document.querySelectorAll('.kaching-bundles, kaching-bundles');
    for (var h = 0; h < hostAll.length; h++) roundPercents(hostAll[h]);
    var sel = document.querySelector('.kaching-bundles__bar--selected');
    var row = document.querySelector('.deen-price');
    if (!sel || !row || !vis(sel)) return;
    var disc = txt(sel.querySelector('.kaching-bundles__bar-price'));
    if (!disc) return;
    var full = txt(sel.querySelector('.kaching-bundles__bar-full-price'));
    var title = txt(sel.querySelector('.kaching-bundles__bar-title'));
    function el(cls, before) {
      var n = row.querySelector('.' + cls);
      if (!n) { n = document.createElement('span'); n.className = cls; before ? row.insertBefore(n, before) : row.appendChild(n); }
      return n;
    }
    var now = el('deen-price__now');
    now.textContent = disc;
    var was = row.querySelector('.deen-price__was');
    if (full) { was = was || el('deen-price__was', now); was.textContent = full; was.style.display = ''; }
    else if (was) { was.style.display = 'none'; }
    var m = title.match(/save\s*(\d+)\s*%/i);
    var badge = row.querySelector('.deen-price__save');
    if (m) { var pct = floor5(parseInt(m[1], 10)); badge = badge || el('deen-price__save'); badge.textContent = 'Save ' + pct + '%'; badge.style.display = ''; }
    else if (badge) { badge.style.display = 'none'; }
    var sticky = document.querySelector('.deen-sticky__price');
    if (sticky) sticky.textContent = disc;
  }
  document.addEventListener('change', function (e) { if (e.target && /kaching-bundles-deal/i.test(e.target.name || '')) setTimeout(sync, 60); }, true);
  document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('.kaching-bundles__bar')) setTimeout(sync, 90); }, true);
  var tries = 0;
  var iv = setInterval(function () {
    sync();
    var host = document.querySelector('.kaching-bundles');
    if (host && !host.__deenSynced) {
      host.__deenSynced = true;
      try { new MutationObserver(function () { setTimeout(sync, 40); }).observe(host, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] }); } catch (e) {}
    }
    if (++tries > 40) clearInterval(iv);
  }, 400);
  var hide = document.querySelector('[data-deen-hide-kaching]');
  if (hide) {
    var h = function () { document.querySelectorAll('kaching-bundles,[class*="kaching"],[id*="kaching"]').forEach(function (n) { n.style.setProperty('display', 'none', 'important'); }); };
    h();
    var mo = new MutationObserver(h);
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 10000);
  }
})();
